import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: "Home", path: "/" },
    { name: "Products", path: "/products" },
    { name: "About", path: "/about" },
    { name: "Services", path: "/services" },
    { name: "Quality", path: "/quality" },
    { name: "Downloads", path: "/downloads" },
    { name: "Contact", path: "/contact" },
  ];

  const navStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1050,
    backgroundColor: 'rgba(0, 0, 0, 0.9)',
    backdropFilter: 'blur(8px)',
    borderBottom: '1px solid #3a3a3a'
  };

  const containerStyle = {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 1.5rem'
  };

  const headerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '4rem'
  };


  const desktopMenuStyle = {
    display: 'flex',
    gap: '2rem'
  };

  const navLinkStyle = (isActive) => ({
    fontSize: '0.875rem',
    fontWeight: '500',
    textDecoration: 'none',
    transition: 'color 0.3s',
    color: isActive ? '#dfa926' : '#d1d5db'
  });

  const mobileButtonStyle = {
    background: 'none',
    border: 'none',
    color: 'white',
    cursor: 'pointer'
  };

  const mobileMenuStyle = {
    paddingTop: '1rem',
    paddingBottom: '1rem',
    borderTop: '1px solid #3a3a3a'
  };

  const mobileLinkStyle = (isActive) => ({
    display: 'block',
    padding: '0.5rem 0',
    fontSize: '0.875rem',
    fontWeight: '500',
    textDecoration: 'none',
    transition: 'color 0.3s',
    color: isActive ? '#dfa926' : '#d1d5db'
  });

  return (
    <nav style={navStyle}>
      <div style={containerStyle}>
        <div style={headerStyle}>
          <Link to="/" style={{ display: 'flex', alignItems: 'center' }}>
            <img 
              src="/logo.png" 
              alt="Hestia Doors Logo"
              style={{ height: '2.4rem', width: 'auto' }}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.parentNode.innerHTML = '<div style="color: #dfa926; font-size: 1.5rem; font-weight: bold; text-decoration: none;">HESTIA DOORS</div>';
              }}
            />
          </Link>

          {/* Desktop Menu */}
          <div style={desktopMenuStyle} className="d-none d-md-flex">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                style={navLinkStyle(location.pathname === item.path)}
                onMouseEnter={(e) => e.target.style.color = '#dfa926'}
                onMouseLeave={(e) => e.target.style.color = location.pathname === item.path ? '#dfa926' : '#d1d5db'}
              >
                {item.name}
              </Link>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            style={mobileButtonStyle}
            className="d-md-none"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div style={mobileMenuStyle} className="d-md-none">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                style={mobileLinkStyle(location.pathname === item.path)}
                onClick={() => setIsOpen(false)}
                onMouseEnter={(e) => e.target.style.color = '#dfa926'}
                onMouseLeave={(e) => e.target.style.color = location.pathname === item.path ? '#dfa926' : '#d1d5db'}
              >
                {item.name}
              </Link>
            ))}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
